/**
 * RichMarkdownEditor tải LAZY (chunk riêng ~1.4 MB Milkdown) + khung chờ — cho trang không phải
 * lúc nào cũng soạn thảo: diễn đàn, câu hỏi trong QuizBuilder, câu trả lời khi làm bài.
 * Props giống `RichMarkdownEditor` (dữ liệu vào/ra vẫn là markdown).
 */
import { lazy, Suspense } from "react";
import { Skeleton } from "antd";
import type { RichMarkdownEditorProps } from "./RichMarkdownEditor";

const RichMarkdownEditor = lazy(() =>
  import("./RichMarkdownEditor").then((m) => ({ default: m.RichMarkdownEditor })),
);

export function LazyRichMarkdownEditor(props: RichMarkdownEditorProps) {
  return (
    <Suspense fallback={<Skeleton active paragraph={{ rows: 4 }} />}>
      <RichMarkdownEditor {...props} />
    </Suspense>
  );
}
